import { GetUserSegmentationsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

const useUserSegmentations = () => {
  const { data, loading } = useQuery(GetUserSegmentationsDocument, {})

  const userSegmentations = data?.marketing.userSegmentations

  return {
    loading,
    interestingSections: userSegmentations?.[0]?.interestingSections || [],
    hopesWithFactorial: userSegmentations?.[0]?.hopesWithFactorial || null,
  }
}

export default useUserSegmentations
